import useTranslator from "../../hooks/useTranslator";
import { ViewNoteIcon } from "./ViewMissingDocNoteButton";

// Footer row at the bottom of the Documents card (tenant's own editable
// view only): opens the missing-documents explanation modal. Shows
// "You explained N document(s) to landlords." with an Edit action when the
// tenant already has a note, otherwise a "Something wrong?" prompt.
// Renders nothing when there is nothing to explain and no note to edit.
const MissingDocNoteFooter = ({
  canManage = false,
  missingDocsCount = 0,
  explainedCount = 0,
  onEdit,
}) => {
  const { _t } = useTranslator();
  if (!canManage) return null;
  if (missingDocsCount <= 0 && explainedCount <= 0) return null;

  return (
    <div
      className="d-flex justify-content-end align-items-center gap-2 mt-3"
      style={{ paddingRight: 20 }}
    >
      <ViewNoteIcon />
      {explainedCount > 0 ? (
        <p style={{ margin: 0, fontSize: 14, color: "#253837" }}>
          {explainedCount === 1
            ? _t(
                "missingDocExplainedTextSingular",
                "You explained {{count}} document to landlords.",
                "translation",
                { count: 1 }
              )
            : _t(
                "missingDocExplainedText",
                "You explained {{count}} documents to landlords.",
                "translation",
                { count: explainedCount }
              )}{" "}
          <button
            type="button"
            className="cursor-pointer"
            style={{
              background: "none",
              border: 0,
              padding: 0,
              fontSize: 14,
              fontWeight: 600,
              color: "#253837",
              textDecoration: "underline",
            }}
            onClick={onEdit}
          >
            {_t("edit", "Edit")}
          </button>
        </p>
      ) : (
        <button
          type="button"
          className="cursor-pointer"
          style={{
            background: "none",
            border: 0,
            padding: 0,
            fontSize: 14,
            color: "#253837",
          }}
          onClick={onEdit}
        >
          {_t(
            "missingDocExplainCta",
            "Something wrong with a document? Tell us"
          )}
        </button>
      )}
    </div>
  );
};

export default MissingDocNoteFooter;
